import React from "react";
import { LucideIcon } from "lucide-react";
import styles from "./IconButton.module.scss";

export type IconButtonVariant = "primary" | "ghost";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: LucideIcon;
  variant?: IconButtonVariant;
  size?: number;
}

const IconButton: React.FC<IconButtonProps> = ({ icon: Icon, variant = "primary", size = 18, className, ...props }) => {
  return (
    <button {...props} className={`${styles.iconButton} ${styles[variant]} ${className || ""}`}>
      <Icon size={size} />
    </button>
  );
};

export default IconButton;
